/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Priority_HighInputs */



/**
* | output |
* | --- |
* | "High" |
*
* @param {Manual_Qc_Priority_HighInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_priority_high = /** @type {((inputs?: Manual_Qc_Priority_HighInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Priority_HighInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Elevee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hoch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Alto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Высокий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("高的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("高い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उच्च")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alto")
	return /** @type {LocalizedString} */ ("High")
});